require("./bootstrap")

import mixin from "./components/mixin.js";

const app = new Vue({
	el: '#app',
	mixins: [mixin],
	data: {},
	created: function () {},
	computed: {},
	methods: {}
});